<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <span class="text-h5">Create Class & Assign Teacher</span>
          </v-card-title>

          <v-card-subtitle>
            Fill in the details below to create a new class and assign a teacher.
          </v-card-subtitle>

          <v-card-text>
            <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
              <!-- Select Existing Class -->
              <v-select
                v-model="formData.class_id"
                :items="classList"
                item-text="name"
                item-value="id"
                label="Class"
                :rules="[rules.required]"
                required
              />

              <!-- Class Teacher Name -->
              <v-text-field
                v-model="formData.class_teacher_name"
                label="Class Teacher Name"
                :rules="[rules.required]"
                required
              />

              <!-- Teacher Email -->
              <v-text-field
                v-model="formData.class_teacher_email"
                label="Teacher Email"
                type="email"
                :rules="[rules.required, rules.email]"
                required
              />

              <!-- Password -->
              <v-text-field
                v-model="formData.password"
                label="Teacher Password"
                type="password"
                :rules="[rules.required, rules.password]"
                required
              />

              <!-- Confirm Password -->
              <v-text-field
                v-model="formData.password_confirmation"
                label="Confirm Password"
                type="password"
                :rules="[rules.required, () => formData.password === formData.password_confirmation || 'Passwords must match.']"
                required
              />

              <!-- Submit -->
              <v-btn :disabled="!valid" color="primary" type="submit">
                Create Class & Assign Teacher
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ClassCreate',
  data() {
    return {
      valid: false,
      classList: [],
      formData: {
        class_id: '',
        class_teacher_name: '',
        class_teacher_email: '',
        password: '',
        password_confirmation: '',
        school_id: localStorage.getItem('user_id')
      },
      rules: {
        required: v => !!v || 'This field is required.',
        email: v => /^[a-zA-Z0-9]+[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) || 'Enter a valid email address.',
        password: v => v.length >= 6 || 'Password must be at least 6 characters.'
      },
    };
  },
  created() {
    this.getClasses();
  },
  methods: {
    async submitForm() {
      if (!this.$refs.form.validate()) return;

      try {
        const response = await axios.post('/grade/creategradePanel', this.formData);

        if (response.data.status) {
          this.$swal('success', 'Class and teacher created successfully!');
          this.$router.push({ name: 'list-grade' });
        } else {
          this.$swal('error', response.data.message || 'Failed to create class.');
        }
      } catch (error) {
        console.error('Error:', error);
        this.$swal('error', 'An error occurred while creating the class.');
      }
    },

    async getClasses() {
      try {
        const response = await axios.get('grade/getClassesForGrade', {
          params: {
            school_id: localStorage.getItem('user_id')
          }
        });
        this.classList = response.data.data || response.data;
      } catch (error) {
        console.error('Failed to fetch classes:', error);
        this.$toast?.error('Failed to load class list');
      }
    }
  }
};
</script>

<style scoped>
.v-card {
  max-width: 700px;
  margin: 20px auto;
}
</style>
 